import angular, { ITimeoutService, IWindowService } from "angular";
import { StateObject, StateService, Transition } from "angular-ui-router";
import { configureStates, RouteDeclaration, resolveFromParam } from "../../../core/router/router-helper.provider";
import { AccessDeniedComponent } from "./403.component";
import { NotFoundComponent } from "./404.component";
import { ServiceUnavailableComponent } from "./503.component";
import { AppOutdatedComponent } from "./app-outdated.component";
import { NavigationFailedComponent } from "./navigation-failed.component";
import { SessionExpiredComponent } from "./session-expired.component";

const errorRoutes: RouteDeclaration[] = [{
    state: "403",
    config: {
        url: "/403",
        component: "apex403",
        data: {
            allowAnonymous: true
        }
    }
}, {
    // Show 403 without replacing the URL.
    state: "persisted403",
    config: {
        component: "apex403",
        data: {
            allowAnonymous: true
        }
    }
}, {
    state: "404",
    config: {
        url: "/404",
        component: "apex404",
        data: {
            allowAnonymous: true
        }
    }
}, {
    state: "persisted404",
    config: {
        component: "apex404",
        data: {
            allowAnonymous: true
        }
    }
}, {
    state: "persisted503",
    config: {
        component: "apex503",
        data: {
            allowAnonymous: true
        }
    }
}, {
    state: "navigationFailed",
    config: {
        component: "apexNavigationFailed",
        params: {
            message: "",
            state: null,
            params: null
        },
        resolve: {
            message: resolveFromParam("message"),
            state: resolveFromParam("state"),
            params: resolveFromParam("params")
        },
        data: {
            allowAnonymous: true
        }
    }
}, {
    state: "serverError",
    config: {
        name: "serverError",
        url: "/error",
        params: {
            requireReload: true
        },
        data: {
            isMvc: true,
            allowAnonymous: true,
            skipAuthGuard: true
        }
    }
}, {
    state: "appOutdated",
    config: {
        name: "appOutdated",
        component: "apexAppOutdated",
        params: { targetState: null },
        onEnter: ($state: StateService, $timeout: ITimeoutService, $transition$: Transition,
            $window: IWindowService) => {
            'ngInject';
            $timeout(() => {
                const { targetState } = $transition$.params() as { targetState: StateObject };
                if (targetState) {
                    $window.history.pushState(null, "Reloading Apex...", $state.href(targetState));
                }
                // Reload based on URL; ideally, this will restore the user's previous attempted state,
                // but in some cases (eg, non-URL param arguments), this will not be possible.
                $window.location.reload();
            }, 2000);
        }
    }
}];

/**
 * A component module containing error page components.
 */
export const ErrorsModule = angular
    .module("apex.mainApp.errors", [])
    .component("apex403", AccessDeniedComponent)
    .component("apex404", NotFoundComponent)
    .component("apex503", ServiceUnavailableComponent)
    .component("apexAppOutdated", AppOutdatedComponent)
    .component("apexNavigationFailed", NavigationFailedComponent)
    .component("apexSessionExpired", SessionExpiredComponent)
    .run(configureStates(errorRoutes))
    .name;

